import React, { useEffect, useState, useRef } from "react";
import useStyles from "../common/Styles";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import citiesMap from "../../../../assets/Water_User_Cities_v2.json";
import { Box } from "@material-ui/core";
import { usePrevious } from "components/common/usePrevious";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

var map;
var allModelLayer;
var legend;

const includedCities = {
  "Apache Junction": true,
  "Arizona Water Co. (Superstition)": true,
  "Arizona Water Co. (Pinal)": true,
  "Arizona Water Co. (White Tank)": true,
  Avondale: true,
  Buckeye: true,
  "Carefree Water Co.": true,
  "Cave Creek": true,
  Chandler: true,
  "Chaparral City Water Co.": true,
  "Circle City Water Co.": true,
  "Community Water Co. of Green Valley": true,
  "Del Webb": true,
  "El Mirage": true,
  Eloy: true,
  "EPCOR (Agua Fria)": true,
  "EPCOR (Paradise Valley)": true,
  "EPCOR (Sun City)": true,
  "EPCOR (Sun City West)": true,
  "EPCOR (San Tan)": true,
  Florence: true,
  "Flowing Wells Irrigation District": true,
  Gilbert: true,
  Glendale: true,
  Goodyear: true,
  "Green Valley Domestic Water Improvement District": true,
  Marana: true,
  Mesa: true,
  "Metropolitan Domestic Water Improvement District": true,
  "Oro Valley": true,
  Peoria: true,
  Phoenix: true,
  "Queen Creek": true,
  "Rio Verde Utilities": true,
  Scottsdale: true,
  "Spanish Trail Water Co.": true,
  Surprise: true,
  Tempe: true,
  "Tonto Hills Domestic Water Improvement District": true,
  Tucson: true,
  "Vail Water Company": true,
  "Water Utility of Greater Tonopah": true,
  "City of Phoenix- Anthem": true,
};

const includedCityColor = {
  fillColor: "#699EE0",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

const notIncludedCityColor = {
  fillColor: "#C9C9C9",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

function CitiesMap() {
  const classes = useStyles();
  const [opacity] = useState(0.5);
  // const handleSliderChange = (e, value) => {
  //   setOpacity(value);
  // };
  const containerRef = useRef(document.createElement("div"));
  const { toggle_about, city_selected } = useSelector(
    (state) => state.water_user
  );
  const [selectedFeature, setSelectedFeature] = useState(null);
  const previousFeature = usePrevious(selectedFeature);
  const { isMobile } = useGetViewPortDimensions();

  // renders slider component
  // const widget = useMemo(
  //   () => (
  //     <Box className={classes.mapSliderContainer}>
  //       <FormLabel classes={{ root: classes.sliderTitle }}>Opacity</FormLabel>
  //       <Typography variant="caption" className={classes.sliderLabel}>
  //         100%
  //       </Typography>
  //       <Slider
  //         min={0}
  //         max={1}
  //         // marks={marks}
  //         step={0.1}
  //         orientation="vertical"
  //         classes={{
  //           root: classes.slider,
  //           rail: classes.sliderRail,
  //           valueLabel: classes.sliderValueLabel,
  //           thumb: classes.sliderThumb,
  //           vertical: classes.sliderVertical,
  //         }}
  //         defaultValue={opacity}
  //         onChange={handleSliderChange}
  //       />
  //       <Typography variant="caption" className={classes.sliderLabel}>
  //         0%
  //       </Typography>
  //     </Box>
  //   ),
  //   []
  // );

  const onEachFeature = (feature, layer) => {
    layer
      .setStyle(
        includedCities.hasOwnProperty(feature.properties.combined_4)
          ? includedCityColor
          : notIncludedCityColor
      )
      .bindTooltip(feature.properties.combined_4, { direction: "top" });

    if (feature.properties.combined_4 === city_selected.name) {
      highlightFeature(layer);
      setSelectedFeature(layer);
    }
  };

  const highlightFeature = (layer) => {
    // let layer = e.target;
    layer.setStyle({
      weight: 3,
      color: "#3559C8",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }

    map.setView(
      new L.LatLngBounds(
        new L.LatLng(
          layer._bounds._northEast.lat,
          layer._bounds._northEast.lng
        ),
        new L.LatLng(layer._bounds._southWest.lat, layer._bounds._northEast.lng)
      ).getCenter(),
      10
    );
  };

  useEffect(() => {
    if (map) {
      map.remove();
    }
    map = L.map("map", {
      center: new L.LatLngBounds(
        new L.LatLng(31.9, -113),
        new L.LatLng(35.2, -111.2)
      ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      zoom: 6,
      maxZoom: 17,
      // maxZoom: 11,
      minZoom: 5,
      maxBounds: [
        //south-west coordinates
        // [32, -113],
        [30, -115],
        //north-east coordinates
        // [35, -111.0]
        [37.5, -108.0],
      ],
      maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // add zoom control
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);
  }, [toggle_about]);

  const featureMap = () => {
    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(citiesMap, {
      onEachFeature,
    }).addTo(map);
  }
  useEffect(featureMap, [opacity, toggle_about, city_selected]);

  const setDOM = () => {
    if (legend) {
      legend.remove();
    }
    legend = L.control({ position: "topleft" });
    legend.onAdd = function (map) {
      var div = L.DomUtil.create("div", "infoCity legend");
      // div.innerHTML += `<div style="padding: 18px 0px 18px 0px" class='legendTitle'> </div>`;
      // TODO: if city adds title, use same styling as industry, else use infoCity class for styling using flex
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#699EE0"></i><span class='legendLabel'>Lorem ipsum</span></div>`;
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#9F9F9F"></i><span class='legendLabel'>No data</span></div>`;
      return div;
    };
    legend.addTo(map);
  }
  useEffect(setDOM, [map]);


  const setPrevFeature = () => {
    if (previousFeature) {
      previousFeature.setStyle({
        fillColor: "#699EE0",
        fillOpacity: 0.5,
        weight: 1,
        color: "#707070",
      });
    }
  }
  useEffect(setPrevFeature, [selectedFeature]);


  const setRefElement = () => {
    if (map) {
      const Control = L.Control.extend({
        onAdd() {
          L.DomEvent.disableScrollPropagation(containerRef.current);
          containerRef.current.onmouseenter = (e) => map.dragging.disable();
          containerRef.current.onmouseleave = (e) => map.dragging.enable();
          return containerRef.current;
        },
      });
      const control = new Control({
        position: "bottomright",
      });
      map.addControl(control);
      return () => {
        map.removeControl(control);
      };
    }
  }
  useEffect(setRefElement, [map, toggle_about]);

  // renders the slider in a div component
  // useEffect(() => {
  //   if (widget) {
  //     const container = containerRef.current;
  //     ReactDOM.render(widget, container);
  //   }
  // }, [widget]);

  useEffect(() => {
    const container = containerRef.current;
    return () => {
      ReactDOM.unmountComponentAtNode(container);
    };
  }, [containerRef]);

  return (
    <Box className={isMobile ? classes.mapAreaResponsive : classes.mapArea}>
      <div className={isMobile ? classes.mapResponsive : classes.map} id="map"></div>
    </Box>
  );
}

export default CitiesMap;
